<template>
	<div class="row dynvibeRow">
		<div class="col-lg-6 col-xs-12">
			<div class="dynvibeBox" style="min-height: 100px">
				<div class="col-lg-2 dynvibeTitleBox">
					<h2><span class="dynvibeTitleTopicsBrandsPeople">Topics</span></h2>
				</div>
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-if="!loading && noData" class="noData">
					<p>No Data to display</p>
				</div>
				<div v-if="!loading && !noData" class="col-lg-10">
					<div class="col-lg-4 col-xs-12 details">
						<span class="details-profiles">Profiles</span><br />
						<span class="dynvibeProfilesDetailsValue">{{ totalProfiles }}</span>
					</div>
					<div class="col-lg-4 col-xs-12 details">
						<span class="details-posts">Posts</span><br />
						<span class="dynvibeProfilesDetailsValue">{{ totalPosts }}</span>
					</div>
					<div class="col-lg-4 col-xs-12 details">
						<span class="details-engagement">Avg. Engagement</span><br />
						<span class="dynvibeProfilesDetailsValue">{{ Math.round((impact_score + Number.EPSILON) * 100) / 100 }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="dynvibeBox" style="min-height: 100px">
				<span style="font-size: 16px; font-weight: 700; color: rgb(239, 64, 46); text-transform: uppercase">Location</span><br />
				<div v-if="loading" class="dynvibeLoading"></div>
				<div v-else-if="!loading && noData" class="noData">
					<p>No Data to display</p>
				</div>
				<div v-else class="dynvibeProfilesDetailsLoca">
					<span
						v-for="(country, index) in countries"
						:key="index"
						style="margin-right: 5px"
						:class="[index == 0 ? 'dynvibeProfilesDetailsLocaFirst' : 'dynvibeProfilesDetailsLoca']"
					>
						{{ country }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "ExploreCounts",
	props: {
		filters: {
			type: Object,
			default: function () {
				return {};
			},
		},
		keyword: {
			type: String,
			default: "",
		},
		level: {
			type: String,
			default: "",
		},
		date: {
			type: Object,
			default: function () {
				return {
					gte: "",
					lte: "",
				};
			},
		},
		country: {
			type: String,
			default: "",
		},
	},
	data() {
		return {
			totalProfiles: 0,
			totalPosts: 0,
			impact_score: 0,
			countries: {},
			loading: true,
			noData: true,
		};
	},
	mounted: function () {
		/*let sent = { mastertag: this.keyword };
		if (this.level == "categories") {
			sent = { category: this.keyword };
		} else if (this.level == "subcategories") {
			sent = { subcategory: this.keyword };
		}*/

		let filters = { ...this.filters };
		if (this.date.gte != "") {
			filters.date = this.date;
		}
		if (this.country != "") {
			filters.country = [this.country];
		}

		this.getData("exploreCounts", {
			level: this.level,
			mainkeyword: this.keyword,
			parameters: filters,
		});
	},
	methods: {
		treatResponse(response) {
			this.totalProfiles = response.data.totalProfiles;
			this.impact_score = response.data.impact_score;
			this.totalPosts = response.data.totalPosts;
			this.countries = response.data.countries.filter((v) => v);
			this.loading = false;
			if (this.totalProfiles > 0) {
				this.noData = false;
			}
		},
	},
};
</script>

<style scoped>
div.details {
	margin-top: 0px;
}

span.details-profiles {
	font-size: 12px;
	font-weight: 700;
	color: #23056b;
	text-transform: uppercase;
}

span.details-posts {
	font-size: 12px;
	font-weight: 700;
	color: #ef402e;
	text-transform: uppercase;
}

span.details-engagement {
	font-size: 12px;
	font-weight: 700;
	color: #33d1cd;
	text-transform: uppercase;
}

.dynvibeProfilesDetailsValue {
	font-size: 36px;
}

.dynvibeProfilesDetailsLocaFirst {
	position: relative;
	top: -5px;
	line-height: 1;
	font-family: "Montserrat";
	font-size: 36px;
	font-weight: 700;
	text-transform: uppercase;
	color: #33d1cd;
}

.dynvibeProfilesDetailsLoca span {
	position: relative;
	top: -5px;
	line-height: 1;
	font-family: "Montserrat";
	font-size: 36px;
	font-weight: 700;
	text-transform: uppercase;
	color: #23056b;
}

.dynvibeProfilesDetailsLoca span:first-child {
	color: #33d1cd;
}
</style>
